export default "__VITE_ASSET__DOenq03J__"